export default "__VITE_ASSET__BK41FvN1__"